<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="敏感词">
        <el-input
          v-model="queryForm.word"
          placeholder="请填写敏感词"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getWordList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addChat"
          >新建</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshWordList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="chatList"
        width="100%"
        row-key="requestId"
        size="small"
        height="100%"
        @selection-change="handleSelectionChange"
        :default-expand-all="true"
        v-loading="loading"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="5%"
        > </el-table-column>
        <el-table-column
          align="center"
          prop="wordId"
          label="敏感词序号"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          align="center"
          prop="word"
          label="敏感词"
          min-width="20%"
        > </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          min-width="10%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="deleteChat(scop.row.wordId)">
                <Icon
                  size="16"
                  style="color: red"
                >
                  <Delete24Regular />
                </Icon>
                <span
                  class="operation-label"
                  style="color: red"
                >删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>

      <!-- 添加 -->
      <el-dialog
        :title="'添加敏感词'"
        :visible.sync="showDialog"
        width="400px"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="sensitiveWord"
            ref="sensitiveWordForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="mini"
          >
            <el-form-item
              label="敏感词"
              prop="word"
            >
              <el-input
                size="small"
                style="width: 200px"
                v-model="sensitiveWord.word"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {},
    data() {
        return {
            timeRange: [],
            queryForm: {
                word: ''
            },
            sensitiveWord: {
                //敏感词对象
                word: '' //敏感词
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            multipleSelection: [],
            chatList: [],
            btnLoading: false,
            rules: {
                word: [{ required: true, message: '敏感词不能为空', trigger: 'blur' }]
            },
            friendId: ''
        };
    },
    created() {
        this.getWordList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        //重置
        resetDialog() {
            this.queryForm = {
                word: ''
            };
            this.getWordList();
        },
        //获取敏感词列表
        getWordList() {
            this.loading = true;
            get(`/im/sensitive/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.chatList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getWordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getWordList();
        },
        refreshWordList() {
            this.getWordList();
        },
        //删除敏感词
        deleteChat(wordId) {
            let ids = '';
            if (wordId) {
                ids = wordId;
            } else {
                ids = this.multipleSelection.map((word) => word.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    get(`/im/sensitive/deleteSensitiveWord`, { wordId: ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetDialog();
                            this.getWordList();
                        }
                    });
                })
                .catch(() => {});
        },
        //打开敏感词窗口
        addChat() {
            this.showDialog = true;
            this.sensitiveWord = {};
        },
        //添加敏感词
        submitForm() {
            this.$refs.sensitiveWordForm.validate((valid) => {
                if (valid) {
                    post(`/im/sensitive/addSensitiveWord`, { ...this.sensitiveWord }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetDialog();
                            this.getWordList();
                        }
                    });
                }
            });
            this.showDialog = false;
            this.sensitiveWord = {};
        },
        //关闭窗口
        closeDialog() {
            this.showDialog = false;
            this.sensitiveWord = {};
            this.$refs['sensitiveWordForm'].resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
</style>